export const NA_OPTION = {
  key: 'n/a',
  value: 'N/A',
  thumb: 'N/A',
};
